<script>
import { BAN_LOG_ITEM_TYPE_BAN   } from '../model/player_ban.js';
import { BAN_LOG_ITEM_TYPE_UNBAN } from '../model/player_ban.js';

import PlayerBanPreview from './PlayerBanPreview.vue';
import PlayerUnbanPreview from './PlayerUnbanPreview.vue';

export default {
  name: 'PlayerBanLogItem',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    object: {
      type: Object,
      required: true,
    },

    userMap: {
      type: Map,
      required: true,
    },
  },

  render(createElement) {
    const componentType = getComponentType(this.object.type);
    const data = {
      props: {
        playerId: this.playerId,
        object:   this.object,
        userMap:  this.userMap,
      },
    };
    return createElement(componentType, data);
  },
}

function getComponentType(purpose) {
  switch(purpose) {
    case BAN_LOG_ITEM_TYPE_BAN:
      return PlayerBanPreview;
    case BAN_LOG_ITEM_TYPE_UNBAN:
      return PlayerUnbanPreview;
  }
  return null;
}
</script>
